import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ShowMe = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/game/4e759805-65b1-488f-892d-655911516b82');
    }, [navigate]);

    return null;
};

export default ShowMe;
